const ROLE_LABELS = {
  owner: 'Owner',
  manager: 'Manager',
  lister: 'Lister',
  viewer: 'Viewer',
};

function roleLabel(role) {
  return ROLE_LABELS[role] || role || '';
}

export { roleLabel };
